import { actionsToArray } from '@noven-prime/lattice-core';
import { mediaLibraryActions } from './actions.js';
/**
 * Media Library Capability Manifest
 *
 * Manages the site's images and files in the `media` blob container.
 */
export const mediaLibraryManifest = {
    id: 'media-library',
    name: 'Media Library',
    description: 'Upload and manage the images used across the public website',
    version: '1.0.0',
    surfaces: {
        allowed: '*',
    },
    experiences: {
        allowed: '*',
    },
    actions: actionsToArray(mediaLibraryActions),
    features: [
        {
            id: 'media-management',
            name: 'Media Management',
            description: 'Upload, list, and delete site media',
            actions: actionsToArray(mediaLibraryActions),
        },
    ],
};
//# sourceMappingURL=manifest.js.map